import { LivestreamCountdown } from "./livestream-countdown";
import $ from "jquery";
import { padNumber } from "./utils";

class Countdown extends LivestreamCountdown {

    constructor($element, $countdown, targetTime) {
        super($element, $countdown, targetTime);

        this.$days = $countdown.find('.countdown-days').first();
        this.$hours = $countdown.find('.countdown-hours').first();
        this.$minutes = $countdown.find('.countdown-minutes').first();
        this.$seconds = $countdown.find('.countdown-seconds').first();
    }

    updateDisplay(days, hours, minutes, seconds) {
        this.$days.text(padNumber(days));
        this.$hours.text(padNumber(hours));
        this.$minutes.text(padNumber(minutes));
        this.$seconds.text(padNumber(seconds));
    }
}

export default function() {
    const componentSelector = ".component-countdown";

    $(componentSelector).each(function() {
        const countdownElement = $(this).find(`${componentSelector}__countdown`).first();

        const countdown = new Countdown($(this), countdownElement, new Date($(this).data("target-time")));
        countdown.init();
    });
}
